import React from 'react';
import dynamic from 'next/dynamic';
import { useIntl } from 'react-intl';
import Frontpage from '@fuww/library/src/Frontpage';
import ArticleLayout from '../News/ArticleLayout';
import About from './Sections/About';
import HomeLink from '../HomeLink';
import SpecialLinks from '../Navigation/SpecialLinks';
import LinkAndAnchor from '../LinkAndAnchor';
import Head from '../Head';
import InView from '../InView';
import messages from '../../lib/messages';
import loading from '../../lib/loading';
import aboutInfo from '../../data/education';

const CategoryTags = dynamic(() => import('./Sections/CategoryTags'), {
  ssr: false,
  loading,
});

const specialLinks = [
  {
    text: 'Fashion School Directory',
    href: 'https://fashionunited.com/schools',
    router: true,
    route: 'schools',
  },
  {
    text: 'Course Directory',
    href: 'https://fashionunited.com/education/courses',
    router: true,
    route: 'courses',
  },
  {
    text: 'Internships',
    href: 'https://fashionunited.com/landing/fashion-internships-in/global',
    router: true,
    route: 'landing',
    params: {
      landingPrefix: 'landing',
      path: 'fashion-internships-in/global',
    },
  },
];

const Education = () => {
  const intl = useIntl();
  const educationNewsCategoryIds = [25];
  const educationSchoolsCategoryIds = [26];
  const intro = intl.formatMessage(messages.educationIntro);
  const {
    title: { id }, description, contact: { email, telephone },
  } = aboutInfo;

  const FEATURED_NEWS_QUERY_VARIABLES = {
    categoryIds: educationNewsCategoryIds,
    featured: null,
  };
  const MORE_NEWS_QUERY_VARIABLES = {
    categoryIds: educationSchoolsCategoryIds,
  };

  return (
    <>
      <Head
        title={intro}
        description={intl.formatMessage(messages.educationPageMetaDescription)}
      />
      <Frontpage
        breadcrumbs={[
          <HomeLink />,
          <LinkAndAnchor
            route="education"
            passHref
          >
            {intl.formatMessage(messages.education)}
          </LinkAndAnchor>,
        ]}
        intro={intro}
        description={intl.formatMessage(messages.educationDescription)}
        specialLinks={(<SpecialLinks links={specialLinks} />)}
        mainSection={(
          <ArticleLayout
            featuredVariables={FEATURED_NEWS_QUERY_VARIABLES}
            moreNewsVariables={MORE_NEWS_QUERY_VARIABLES}
            categorySection={(
              <InView>
                <CategoryTags
                  educationNewsCategoryIds={educationNewsCategoryIds}
                  educationSchoolsCategoryIds={
                    educationSchoolsCategoryIds
                  }
                />
              </InView>
            )}
          />
        )}
        aboutSection={(
          <About
            title={intl.formatMessage(messages[id])}
            description={description}
            contactTitle={intl.formatMessage(messages.contact)}
            email={email}
            telephone={telephone}
          />
        )}
      />
    </>
  );
};

export default Education;
